import { demoEdgeMockFirmwareReleases } from './demoEdgeMockFirmwareReleases';

const getReleaseNotesByVersion = (releases, version) => {
  const release = releases.find((r) => r.version === `v${version}`);
  return release ? release.releaseNotes : null;
};

export const demoEdgeMockEdgeControllers = [
  {
    edgeControllerId: 'EC-HW-2024-001-A',
    name: 'NYC Downtown Controller',
    online: true,
    onlineTs: '2026-02-04T18:06:03Z',
    customerId: 'valeo',
    customerName: 'Valeo',
    plazaId: 'plaza-001',
    plazaName: 'Downtown Charging Hub',
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-002-B',
    name: 'LAX Airport Controller',
    online: true,
    onlineTs: '2026-02-08T10:30:15Z',
    customerId: 'zeborne',
    customerName: 'ZEborne',
    plazaId: 'plaza-002',
    plazaName: 'Airport Plaza Station',
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-003-G',
    name: 'Chicago Mall Controller',
    online: false,
    onlineTs: '2026-02-07T14:22:45Z',
    customerId: 'valeo',
    customerName: 'Valeo',
    plazaId: 'plaza-003',
    plazaName: 'Shopping Mall Station',
    firmwareVersion: '2.4.9',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-004-D',
    name: 'Houston Center Controller',
    online: true,
    onlineTs: '2026-02-09T00:42:18Z',
    customerId: 'echo-qa',
    customerName: 'PowerGrid Solutions',
    plazaId: 'plaza-004',
    plazaName: 'City Center Station',
    firmwareVersion: '2.5.0',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-005-E',
    name: 'Phoenix Unit',
    online: true,
    onlineTs: '2026-02-05T16:15:00Z',
    customerId: 'zeborne',
    customerName: 'Metro Charging Services',
    plazaId: null,
    plazaName: null,
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-006-Z',
    name: 'Philly Highway Controller',
    online: false,
    onlineTs: '2026-02-06T08:45:30Z',
    customerId: 'zeborne',
    customerName: 'ZEborne',
    plazaId: 'plaza-005',
    plazaName: 'Highway Rest Stop',
    firmwareVersion: '2.4.8',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-007-H',
    name: 'University Campus Controller',
    online: true,
    onlineTs: '2026-02-03T12:00:00Z',
    customerId: 'valeo',
    customerName: 'Valeo',
    plazaId: 'plaza-006',
    plazaName: 'University Campus Station',
    firmwareVersion: '2.5.0',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-008-T',
    name: 'San Diego',
    online: true,
    onlineTs: '2026-02-08T22:10:05Z',
    customerId: 'zeborne',
    customerName: 'Metro Charging Services',
    plazaId: null,
    plazaName: null,
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-009-I',
    name: 'Dallas Residential Controller',
    online: true,
    onlineTs: '2026-02-01T09:30:00Z',
    customerId: 'echo-qa',
    customerName: 'EcoCharge Inc',
    plazaId: 'plaza-007',
    plazaName: 'Residential Complex',
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-010-K',
    name: 'San Jose Controller',
    online: false,
    onlineTs: '2026-02-05T03:20:12Z',
    customerId: 'echo-qa',
    customerName: 'PowerGrid Solutions',
    plazaId: null,
    plazaName: null,
    firmwareVersion: '2.4.7',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-011-L',
    name: 'Austin Train Station',
    online: true,
    onlineTs: '2026-02-07T19:55:33Z',
    customerId: 'zeborne',
    customerName: 'Metro Charging Services',
    plazaId: 'plaza-008',
    plazaName: 'Train Station Plaza',
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
  {
    edgeControllerId: 'EC-HW-2024-012-M',
    name: 'Jacksonville',
    online: true,
    onlineTs: '2026-02-02T14:40:22Z',
    customerId: 'zeborne',
    customerName: 'Metro Charging Services',
    plazaId: null,
    plazaName: null,
    firmwareVersion: '2.5.1',
    get releaseNotes() {
      return getReleaseNotesByVersion(demoEdgeMockFirmwareReleases, this.firmwareVersion);
    },
  },
];
